import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/tier3.gif")